import {
  SystemNamesEnum,
  WorkflowExternalStepDefDtoModel,
  WorkflowUiDefinitionModel
} from "@well/iriro-frontend-libs/workflows/domain";
import {DefinitionsNameEnum} from "./DefinitionsName.enum";

class LogoDefinition implements WorkflowUiDefinitionModel {
  configuredBy = null;
  configuredForOwner = false;
  defaultLabel = null
  name = DefinitionsNameEnum.LOGO
  systemName = SystemNamesEnum.ANGULAR_FRONTEND
  definitionFile = 'LogoDefinition3'
  uiSteps = {
    displayLogoInHeader: WorkflowExternalStepDefDtoModel.createWorkflowStepVoModel(DefinitionsNameEnum.LOGO + '_1', SystemNamesEnum.ANGULAR_FRONTEND),
    displayLogoInOtherPlace: WorkflowExternalStepDefDtoModel.createWorkflowStepVoModel(DefinitionsNameEnum.LOGO + '_2', SystemNamesEnum.ANGULAR_FRONTEND)
  }
  uuid = null
  valid = null
  validFrom = null
  validTo = null
}

export const logoDefinition = new LogoDefinition();

